<script setup lang="ts">
import { computed } from 'vue'
import {
  getDashboardNavIcon,
  type DashboardNavIconName,
} from '@/helpers/dashboardNavIcons'

const props = defineProps<{
  name: DashboardNavIconName
}>()

const glyph = computed(() => getDashboardNavIcon(props.name))

const svgAttrs = computed(() => {
  if (glyph.value.variant === 'outline') {
    return {
      viewBox: glyph.value.viewBox,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 1.5,
      'stroke-linecap': 'round' as const,
      'stroke-linejoin': 'round' as const,
    }
  }

  return {
    viewBox: glyph.value.viewBox,
    fill: 'currentColor',
  }
})
</script>

<template>
  <svg v-bind="svgAttrs" aria-hidden="true">
    <path
      v-for="(path, index) in glyph.paths"
      :key="index"
      :d="path.d"
      :fill-rule="path.fillRule"
      :clip-rule="path.clipRule"
    />
  </svg>
</template>
